import image from '../assets/images/client-logos/client_logo_OntarioPowerGeneration.png';
import image1 from '../assets/images/client-logos/client_logo_Vale.png';
import image2 from '../assets/images/client-logos/client_logo_NETCO.png';
import image3 from '../assets/images/client-logos/client_logo_USAirForce.png';
import image4 from '../assets/images/client-logos/client_logo_DFW.png';
import image5 from '../assets/images/client-logos/client_logo_UnitedStatesNavy.png';
import image6 from '../assets/images/client-logos/client_logo_SouthernArkansasUniversity.png';
import image7 from '../assets/images/client-logos/client_logo_UnitedStatesSpaceForce.png';
import image8 from '../assets/images/client-logos/client_logo_ECAO.png';
import image9 from '../assets/images/client-logos/client_logo_IBEW.png';
import image10 from '../assets/images/client-logos/client_logo_UnitedStatesDepartmentOfVeteransAffairs.png';
import image11 from '../assets/images/client-logos/client_logo_ScienceNorth.png';
import image12 from '../assets/images/client-logos/client_logo_DynamicEarth.png';
import image13 from '../assets/images/client-logos/client_logo_OntarioMineRescue.png';
import image14 from '../assets/images/client-logos/client_logo_CFA.png';
import image15 from '../assets/images/client-logos/client_logo_Snolab.png';
import image16 from '../assets/images/client-logos/client_logo_BrucePower.png';
import image17 from '../assets/images/client-logos/client_logo_AgnicoEagle.png';
import image18 from '../assets/images/client-logos/client_logo_CanadianArmedForces.png';

const clients = [
    {
        url: '#',
        image: {
            src: image,
            alt: 'Ontario Power Generation',
        },
    },
    {
        url: '#',
        image: {
            src: image1,
            alt: 'Vale',
        },
    },
    {
        url: '#',
        image: {
            src: image2,
            alt: 'NETCO',
        },
    },
    {
        url: '#',
        image: {
            src: image3,
            alt: 'US Air Force',
        },
    },
    {
        url: '#',
        image: {
            src: image4,
            alt: 'DFW',
        },
    },
    {
        url: '#',
        image: {
            src: image5,
            alt: 'United States Navy',
        },
    },
      {
        url: '#',
        image: {
            src: image6,
            alt: 'Southern Arkansas University',
        },
    },
      {
        url: '#',
        image: {
            src: image7,
            alt: 'United States Space Force',
        },
    },
      {
        url: '#',
        image: {
            src: image8,
            alt: 'ECAO',
        },
    },
      {
        url: '#',
        image: {
            src: image9,
            alt: 'IBEW',
        },
    },
          {
        url: '#',
        image: {
            src: image10,
            alt: 'United States Department of Veterans Affairs',
        },
    },
          {
        url: '#',
        image: {
            src: image11,
            alt: 'Science North',
        },
    },
          {
        url: '#',
        image: {
            src: image12,
            alt: 'Dynamic Earth',
        },
    },
    {
        url: '#',
        image: {
            src: image13,
            alt: 'Ontario Mine Rescue',
        },
    },
    {
        url: '#',
        image: {
            src: image14,
            alt: 'CFA',
        },
    },
    {
        url: '#',
        image: {
            src: image15,
            alt: 'Snolab',
        },
    },
        {
        url: '#',
        image: {
            src: image16,
            alt: 'Bruce Power',
        },
    },
    {
        url: '#',
        image: {
            src: image17,
            alt: 'Agnico Eagle',
        },
    },
        {
        url: '#',
        image: {
            src: image18,
            alt: 'Canadian Armed Forces',
        },
    },
];

export default clients;
